/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
// const header = document.querySelector('.shopify-section-header');
// const logo = document.querySelector('.header__logo-img');

// let lastScrollPosition = 0;

// window.addEventListener('scroll', () => {
//   const currentScrollPosition = window.scrollY;

//   if (currentScrollPosition > lastScrollPosition) {
//     // Scrolling down
//     header.classList.remove('header-up');
//     header.classList.add('header-down');
//     logo.style.transform = 'scale(1)';
//   } else {
//     // Scrolling up
//     if (currentScrollPosition === 0) {
//       // At the top
//       header.classList.remove('header-down');
//       header.classList.add('header-up');
//       logo.style.transform = 'scale(1)';
//     } else {
//       header.classList.remove('header-down');
//       header.classList.add('header-up');
//       logo.style.transform = 'scale(0.8)';
//     }
//   }

//   lastScrollPosition = currentScrollPosition;
// });
// Insert any custom theme js here...
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}